import React from 'react'
import { Button, Result } from 'antd'
import { Footer, HeaderB2B } from 'components'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  const pageMeta = {
    title: '404 - Page Not Found',
    description: 'Sorry, the page you visited does not exist.',
    keywords: 'electrum, 404, page not found, error',
  };

  return (
    <div>
      <Helmet>
        <title>{pageMeta.title}</title>
        <meta name="title" content={pageMeta.title} />
        <meta name="description" content={pageMeta.description} />
        <meta name="keywords" content={pageMeta.keywords} />
        <meta property="og:title" content={pageMeta.title} />
        <meta property="og:description" content={pageMeta.description} />
        <link rel="canonical" href="https://electrum.id/404" />
        <meta name="prerender-status-code" content="404" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <HeaderB2B />

      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back to Home
          </Button>
        }
      />

      <Footer />
    </div>
  )
}

export default NotFound
